import React from "react";

export default function CheckBoxUnChecked(): React.JSX.Element {
  return (
    <div className="scd-checkbox-unchecked">
      <svg version="1.1" x="0px" y="0px" viewBox="0 0 30 30">
        <path className="st0" d="M29.5,0.5h-29v29h29V0.5z" />
      </svg>
    </div>
  );
}
